














import { i18n } from '@/i18n';
import { IconType, showToast } from '@tencent/wphk-act-base-ui';
import { jumpPage } from '@tencent/wphk-components-jump-page';
import { defineComponent } from '@vue/composition-api';
import SvgIcon from '@/components/common/svg-icon.vue';
export default defineComponent({
  props: {
    iconName: {
      type: String,
      default: 'arrow-right',
    },
  },
  name: 'ToCouponsBtn',
  components: {
    SvgIcon,
  },
  setup() {
    // 跳轉優惠券列表
    const jumpCouponList = () => {
      showToast({
        title: i18n('跳轉中...'),
        duration: 1000,
        icon: IconType.loading,
      });
      jumpPage.goMyCoupons({ adtag: 'eStampStampModule' });
    };
    return { jumpCouponList };
  },
});
